<template>
  <div class="t-certificates-modal">
    <h4 v-if="props.name" class="t-certificates-modal__name">{{ props.name }}</h4>
    <div class="t-certificates-modal__img" :class="[props.class]">
      <img :src="props.img" :alt="props.name" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: ['props'],
  methods: {
    ...mapActions('modal', ['modalClose']),
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/certificates.vue